import React, { useEffect, useState } from "react";
import Handler from "../../lib/Handlers/main";
import Select from "react-select";
import SelectStyle from "../../lib/ReactSelectTheme/reactSelectStyle";
import { useSelector } from "react-redux";
import { SetTransmissionStatusBody, TransmissionStatusSelect } from "../../../interfaces/main";
import { FIRE_FILENAME, TAXEVE_FILENAME } from "../../lib/constants";
import { calCurrentTaxYear } from "../../lib/calculateTaxYear";
import devLogInstance from "../../lib/loggerConfig";

const transmissionOptions = [
  {
    label: "Awaiting Transmission",
    value: "AwaitingTransmission",
  },
  {
    label: "Transmitted",
    value: "Transmitted",
  },
  {
    label: "Accepted",
    value: "Accepted",
  },
  {
    label: "Rejected",
    value: "Rejected",
  },
];
const transmissionDownloadOptions = [
  {
    label: "Awaiting Transmission",
    value: "AwaitingTransmission",
  },
  {
    label: "Transmitted",
    value: "Transmitted",
  },
  {
    label: "Accepted",
    value: "Form Accepted",
  },
  {
    label: "Rejected",
    value: "Form Rejected",
  },
];

export default function FireFiling() {
  const style = useSelector((state: any) => state.themeChange);
  const [transmissionStatus, setTransmissionStatus] = useState<TransmissionStatusSelect | null>(
    null
  );
  const [transmissionStatusDownload, setTransmissionStatusDownload] =
    useState<TransmissionStatusSelect | null>({
      label: "Awaiting Transmission",
      value: "AwaitingTransmission",
    });
  const [transmissionStatusBody, setBody] = useState<SetTransmissionStatusBody>({
    taxEve_file_name: "",
    fire_file_name: "",
    status: "",
  });
  const [isSubmitBtnDisabled, disableSubmitBtn] = useState(true);

  // Validate the input fields in real time
  useEffect(() => {
    const isValidStatus = transmissionStatusBody.status.length > 0;
    const isValidTaxeveFilename = transmissionStatusBody.taxEve_file_name.length > 0;
    const isValidFireFilename = transmissionStatusBody.fire_file_name.length > 0;

    if (isValidFireFilename && isValidTaxeveFilename && isValidStatus) {
      disableSubmitBtn(false);
      return;
    }
    disableSubmitBtn(true);
  }, [transmissionStatusBody]);

  // Handle ascii file download
  const handleAsciiFileDownload = async (year: number) => {
    try {
      await Handler.handleAsciiFileDownload(year);
    } catch (err) {
      // Error will be handled by error handler
    }
  };

  // Handle transmission status change
  const handleTransmissionStatusChange = (option: TransmissionStatusSelect | null) => {
    if (!option) return;
    setTransmissionStatus(option);
    setBody({
      ...transmissionStatusBody,
      status: option.value,
    });
  };
  // Handle transmission status change
  const handleTransmissionStatusDownload = (option: TransmissionStatusSelect | null) => {
    if (!option) return;
    setTransmissionStatusDownload(option);
  };

  // Handle change event
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id: type, value } = e.currentTarget;

    switch (type) {
      case TAXEVE_FILENAME:
        setBody({
          ...transmissionStatusBody,
          taxEve_file_name: value,
        });
        break;

      case FIRE_FILENAME:
        setBody({
          ...transmissionStatusBody,
          fire_file_name: value,
        });
        break;

      default:
        break;
    }
  };

  // Handle submit
  const handleSubmit = async () => {
    // Handle form submit
    try {
      await Handler.handleSettingTransmissionStatus(transmissionStatusBody);
    } catch (err) {
      // handled by handler
    }
  };

  const downloadTransmissionPendingForm = async () => {
    try {
      await Handler.handleDownloadTransmissionPendingForm(transmissionStatusDownload?.value!);
    } catch (error) {
      devLogInstance.error(error);
    }
  };

  return (
    <div>
      <section className="px-10 py-10 get-ascii-file flex items-center gap-4">
        <button
          className="primary-button py-4 px-6 rounded-xl"
          onClick={() => handleAsciiFileDownload(calCurrentTaxYear())}
        >
          Download ASCII For {calCurrentTaxYear()}
        </button>

        <button
          className="primary-button py-4 px-6 rounded-xl"
          onClick={() => handleAsciiFileDownload(calCurrentTaxYear() - 1)}
        >
          Download ASCII For {calCurrentTaxYear() - 1}
        </button>

        <button
          className="primary-button py-4 px-6 rounded-xl"
          onClick={() => handleAsciiFileDownload(calCurrentTaxYear() - 2)}
        >
          Download ASCII For {calCurrentTaxYear() - 2}
        </button>
      </section>

      <section className="px-10 py-10 set-transmission-status">
        <h2 className="underline underline-offset-2 mb-6">Set the transmission status</h2>
        <div className="flex flex-col gap-6">
          <div className="w-[23%]">
            <Select
              theme={new SelectStyle(style).customTheme}
              styles={new SelectStyle(style).customStyle}
              options={transmissionOptions}
              placeholder="Select transmission status"
              onChange={handleTransmissionStatusChange}
              value={transmissionStatus}
              isSearchable={false}
            />
          </div>
          <input
            id={TAXEVE_FILENAME}
            type="text"
            placeholder="TaxEve Filename"
            className="w-[30%] py-2"
            onChange={handleChange}
            value={transmissionStatusBody.taxEve_file_name}
          />
          <input
            id={FIRE_FILENAME}
            type="text"
            placeholder="Fire Filename"
            className="w-[30%] py-2"
            onChange={handleChange}
            value={transmissionStatusBody.fire_file_name}
          />
          <button
            className={`primary-button py-4 px-4 w-[10%] ${isSubmitBtnDisabled && "opacity-50"}`}
            onClick={handleSubmit}
            disabled={isSubmitBtnDisabled}
          >
            Submit
          </button>
        </div>
        <div>
          <h2 className="underline underline-offset-2 mb-3  mt-8">
            Download transmission pending form
          </h2>
          <div className="w-64 mb-6">
            <Select
              theme={new SelectStyle(style).customTheme}
              styles={new SelectStyle(style).customStyle}
              options={transmissionDownloadOptions}
              placeholder="Select transmission status"
              onChange={handleTransmissionStatusDownload}
              value={transmissionStatusDownload}
              isSearchable={false}
            />
          </div>
          <button
            className="primary-button py-4 px-6 rounded-xl"
            onClick={downloadTransmissionPendingForm}
          >
            Download
          </button>
        </div>
      </section>
    </div>
  );
}
